import {Tabs} from 'antd'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useMemo} from 'react'
import {useParams} from 'react-router-dom'
import {gConfigs, gPaths} from 'views/AppLocals/configs'
import {mapPathParam} from 'views/AppLocals/functions/routerHelper'
import useNavRouteAction from 'views/AppLocals/hooks/useNavRouteAction'
import {NavRoutes} from 'views/AppLocals/hooks/useNavRoutes'
import {notEmpty, NullAsDefault, scrollToSection} from 'views/Shared'
import UserContext from '../UserContext'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

const UserNav = ({Wrapper = 'div'}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const params = useParams()

    const history = useHistory()

    const id = _.get(params, 'id')

    const rootPath = gPaths.user

    const {
        isValidRoute = NullAsDefault,
        routeEntities = [],
        getDefaultAction = NullAsDefault,
        user = {},
    } = useContext(UserContext)

    const defaultAction = getDefaultAction(rootPath)

    const {currentAction} = useNavRouteAction({
        anchor: id,
        defaultAction,
        isAction: isValidRoute,
    })

    const pathTransform = useCallback(
        (path, segment) =>
            [
                _.isEmpty(id)
                    ? path
                    : mapPathParam(path, {
                        id,
                    }),
                segment,
            ]
                .filter(notEmpty)
                .join('/'),
        [id]
    )

    const tabItems = useMemo(
        () =>
            routeEntities
                .filter(
                    ({isInvisible = NullAsDefault}) =>
                        !isInvisible({item: user, isSm})
                )
                .map(({path, breadcrumbName = NullAsDefault}) => ({
                    key: path,
                    label: breadcrumbName(t),
                    children: (
                        <NavRoutes
                            rootPath={rootPath}
                            routes={routeEntities}
                            transform={pathTransform}
                            defaultAction={defaultAction}
                        />
                    ),
                })),
        [t, user, isSm, rootPath, defaultAction, routeEntities, pathTransform]
    )


    return (
        <Wrapper className="space-y-3 h-full">
            <Tabs
                id="tab_content"
                className="h-full"
                tabBarStyle={gConfigs.styles.tabBar}
                destroyOnHidden={true}
                onChange={(activeKey) => {
                    setTimeout(() => {
                        scrollToSection("tab_content")
                    }, 1000);
                    history.push({
                        pathname: pathTransform(rootPath, activeKey),
                        search: _.get(history, 'location.search'),
                    })
                }}
                activeKey={currentAction}
                items={tabItems}>
            </Tabs>
        </Wrapper>
    )
}

export default UserNav
